import { Card, Elevation, Tag } from "@blueprintjs/core";
import React from "react";
import { initials } from "../../fns/util";

import MutEx from "../../utils/MutEx";
import SingleSelectWrapper from "../../utils/SingleSelectWrapper";

class Diagnosis extends React.Component {
  state = {
    editingSite: false,
    editingWhen: false,
    when: "",
  };
  listOfEyes = ["Left Eye", "Right Eye", "Both Eyes"];

  renderDiagnosis = (data) => {
    return (
      <Card
        elevation={Elevation.FOUR}
        style={{
          marginTop: "10px",
          marginBottom: "10px",
          padding: "8px",
          width: "fit-content",
          display: "flex",
          flexDirection: "row",
        }}
        className="colfax"
      >
        <MutEx
          large={this.props.isOld ? false : true}
          minimal={this.props.isOld ? true : false}
          options={["RE", "BE", "LE"]}
          onUpdate={(option) => {
            let opt = {
              RE: "Right Eye",
              LE: "Left Eye",
              BE: "Both Eyes",
            }[option];
            this.props.update(data._id, "site", opt);
          }}
          selected={((x) => {
            let lu = {
              "Right Eye": "RE",
              "Left Eye": "LE",
              "Both Eyes": "BE",
            };
            return lu[x];
          })(data.site)}
        />

        <Tag
          large
          intent="success"
          className="turquoise__bg"
          multiline
          style={{
            marginLeft: `${
              data.laterality && this.props.mode === "CLINICAL" ? "5px" : "5px"
            }`,
          }}
        >
          {data.anatomicalPart}
        </Tag>

        <Tag
          large
          intent="success"
          className="cerulean__bg"
          multiline
          style={{
            marginLeft: `${
              data.laterality && this.props.mode === "CLINICAL" ? "5px" : "5px"
            }`,
          }}
          onRemove={() => this.props.remove(data._id)}
        >
          {data.entityName}
        </Tag>
      </Card>
    );
  };

  render() {
    return <div>{this.renderDiagnosis(this.props.data)}</div>;
  }
}

export default Diagnosis;
